export interface CoreInstanceSettings
{
    mergePersonsAtImport: boolean
    purgeAfterDays: number
}

export interface CorePasswordChangeInstanceSettings
{
   passwordChangeRoles :number
}

export enum CorePasswordChangeRole {
    STUDENT = 1,
    STAFF = 2
}
